import DashboardIcon from "@mui/icons-material/Dashboard";
import SpeedIcon from "@mui/icons-material/Speed"; // Fleet Dashboard
import InsightsIcon from "@mui/icons-material/Insights"; // KPI Dashboard
import CarCrashIcon from "@mui/icons-material/CarCrash"; // Damage & Downtime
import CarRepairIcon from '@mui/icons-material/CarRepair'; // Clutch
import BuildCircleIcon from "@mui/icons-material/BuildCircle"; // Service Status
import LocalShippingIcon from "@mui/icons-material/LocalShipping"; // Delivery and Pickup
import TireRepairIcon from "@mui/icons-material/TireRepair"; // Wheel Alerts
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull"; // Battery and Tyres
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"; // Vehicle Expenses
import PaymentsIcon from "@mui/icons-material/Payments"; // Vendor Payments
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled"; // Overtime Details
import ReviewsIcon from "@mui/icons-material/Reviews"; // Customer Reviews
import BadgeIcon from "@mui/icons-material/Badge"; // Delivery & Pickups Agent Dashboard
import AltRouteIcon from "@mui/icons-material/AltRoute"; // Delivery and Pickup Details
import AddCardIcon from "@mui/icons-material/AddCard";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ArchiveIcon from "@mui/icons-material/Archive";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import FeedbackIcon from "@mui/icons-material/Feedback";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { Navigate, Route } from "react-router-dom";

// Get role and actions
const profileString = localStorage.getItem("profile");
let profile = null;

if (profileString) {
  profile = JSON.parse(profileString);
} else {
  <Route path="*" element={<Navigate to="/" replace />} />;
}

const role = profile?.roles || "";
const actionForThisProfile = profile?.actions || [];
const rolesFromCatalogValues = JSON.parse(localStorage.getItem("catalogValues"))
  ?.role?.inverted;

const catalogValues = JSON.parse(localStorage.getItem("catalogValues"))?.action;

// Check if the role has full access
const privilegedRoles = [
  rolesFromCatalogValues?.superAdmin,
  rolesFromCatalogValues?.tenantAdmin,
  rolesFromCatalogValues?.admin,
  // rolesFromCatalogValues?.franchiseAdmin,
];
const privilegedAcessForAccounts = rolesFromCatalogValues?.accountManager;

const franchiseAdminRole = rolesFromCatalogValues?.franchiseAdmin;
const roleArray = Array.isArray(role) ? role : [role];
const hasFullAccess = roleArray.some((r) =>
  privilegedRoles.includes(String(r)),
);

const filteredActionNames = actionForThisProfile.map(
  (actionId) => catalogValues?.[actionId],
);

const mailtoAccess = ["prateekforwork@gmail.com", "hema@hcube.in" , "mani@wowcarz.in"]

// Final flag to determine if all menu items should be shown
const showAll = hasFullAccess || filteredActionNames.length === 0;

// console.log(
//   "filteredActionNames",
//   filteredActionNames.includes("View All Subscription Inquiry"),
// );

export const routeModules = {
  pettycash: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Petty Cashes Dashboard")
        ? [
            {
              label: "Petty Cash Dashboard",
              icon: DashboardIcon,
              value: false,
              to: "/pettycash/PettycashModule",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("Add Petty Cash Request")
        ? [
            {
              label: "Add Cash Request",
              icon: AddCardIcon,
              value: false,
              to: "/pettycash/AddCashRequestModal",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("View All Petty Cash")
        ? [
            {
              label: "View All",
              icon: CalendarViewWeekIcon,
              value: true,
              to: "/pettycash/AddCashRequestModal",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("Petty Cashes Dashboard")
        ? [
            {
              label: "Bulk Approval",
              icon: FactCheckIcon,
              value: true,
              to: "/pettycash/Bulkapproval",
            },
          ]
        : []),
    ],
  },

  fuelmanagement: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Fuel Logs Dashboard")
        ? [
            {
              label: "Fuel Dashboard",
              icon: DashboardIcon,
              value: false,
              to: "/fuelmanagement/Fuelmanagementmodule",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("Add Fuel Log")
        ? [
            {
              label: "Add Fuel Details",
              icon: LocalGasStationIcon,
              value: false,
              to: "/fuelmanagement/Addfuelrequest",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("View All Fuel Logs")
        ? [
            {
              label: "View All",
              icon: CalendarViewWeekIcon,
              value: true,
              to: "/fuelmanagement/Viewallfuel",
            },
          ]
        : []),
    ],
  },
  // bookings: {
  //   sidebar: [
  //     {
  //       label: "Booking Dashboard",
  //       icon: DashboardIcon,
  //       value: false,
  //       to: "/bookings/Bookingmodule",
  //     },
  //   ],
  // },
  viewallbookings: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View All Booking")
        ? [
            {
              label: "View all Bookings",
              icon: DashboardIcon,
              value: false,
              to: "/viewallbookings/Viewallbookingmodule",
            },
          ]
        : []),
      // ...(showAll || filteredActionNames.includes("View All Booking")
      //   ? [
      //       {
      //         label: "My Bookings",
      //         icon: DashboardIcon,
      //         value: false,
      //         to: "/viewallbookings/Viewallbookingmodule",
      //       },
      //     ]
      //   : []),
      ...(showAll || filteredActionNames.includes("View All Inquries")
        ? [
            {
              label: "View all Inquiry",
              icon: CalendarViewWeekIcon,
              value: false,
              to: "/viewallbookings/Viewallinquiry",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("View All Inquries")
        ? [
            {
              label: "View My Inquiries",
              icon: CalendarViewWeekIcon,
              value: false,
              to: "/viewallbookings/Viewallinquiry",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("Generate Booking")
        ? [
            {
              label: "Add Inquiry",
              icon: AddCircleOutlineIcon,
              value: false,
              to: "/viewallbookings/Addinquiry",
            },
          ]
        : []),

      ...(showAll || filteredActionNames.includes("View All Refund")
        ? [
            {
              label: "View all Refunds",
              icon: DashboardIcon,
              value: false,
              to: "/viewallbookings/Refunds",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("View All Booking")
        ? [
            {
              label: "Available Vehicles",
              icon: EventAvailableIcon,
              value: false,
              to: "/viewallbookings/availablevehciles",
            },
          ]
        : []),
    ],
  },
  peakseason: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Peak Season")
        ? [
            {
              label: "View Peak Season",
              icon: DashboardIcon,
              to: "/peakseasons/Peakseasonmodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("Create Update Peak Season")
        ? [
            {
              label: "Update Peak Season",
              icon: AddCircleOutlineIcon,
              to: "/peakseasons/Peakseasonmodule",
            },
          ]
        : []),
      ...(mailtoAccess.includes(profile?.email)
        ? [
            {
              label: "View All Booking Config",
              icon: DashboardIcon,
              to: "/peakseasons/Peakseasonmodule",
            },
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View All Coupons")
        ? [
            {
              label: "Coupons Configuration",
              icon: DashboardIcon,
              to: "/peakseasons/Peakseasonmodule",
            },
          ]
        : []),
        ...(mailtoAccess.includes(profile?.email)
        ? [
            {
              label: "Cancellation Policies Configuration",
              icon: DashboardIcon,
              to: "/peakseasons/Peakseasonmodule",
            },
          ]
        : []),
    ],
  },
  reports: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Reports Dashboard")
        ? [{ label: "Reports", icon: DashboardIcon, to: "/reports/Reports" }]
        : []),
    ],
  },
  bookingdashboard: {
    sidebar: [
      hasFullAccess || privilegedAcessForAccounts
        ? {
            label: "Dashboard",
            icon: DashboardIcon,
            to: "/bookingdashboard/Bookingdashboardmodule",
          }
        : [],
    ],
  },
  vehiclerevenue: {
    sidebar: [
      hasFullAccess || privilegedAcessForAccounts
        ? {
            label: "Dashboard",
            icon: DashboardIcon,
            to: "/vehiclerevenue/Vehiclerevenuemodule",
          }
        : [],
    ],
  },
  fleetdashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Fleet Overview Dashboard")
        ? [
            {
            label: "Overview",
            icon: SpeedIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
        ...(showAll  || filteredActionNames.includes("View Fleet Kpi Dashboard")
        ? [
            {
            label: "KPI Dashboard",
            icon: InsightsIcon,
            to: "/fleetdashboard/Fleetdashboardmodule", 
          }
          ]
        : []),

        ...(showAll || filteredActionNames.includes("View Fleet Damage And Downtime Dashboard")
        ? [
            {
              label: "Damage & Downtime",
              icon: CarCrashIcon,
              to: "/fleetdashboard/Fleetdashboardmodule",
            },
          ]
        : []),
      
      ...(showAll  || filteredActionNames.includes("View Fleet Service Status Dashboard")
        ? [
            {
            label: "Service Status",
            icon: BuildCircleIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
      ...(showAll  || filteredActionNames.includes("View Fleet Delivery And Pickup Dashboard")
        ? [
            {
            label: "Delivery and Pickup",
            icon: LocalShippingIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View Fleet Wheel Alerts Dashboard")
        ? [
            {
            label: "Wheel Alerts",
            icon: TireRepairIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View Fleet Battery And Tyres Dashboard")
        ? [
            {
            label: "Battery and Tyres",
            icon: BatteryChargingFullIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View Fleet Clutch Dashboard")
        ? [
            {
              label: "Clutch",
              icon: CarRepairIcon,
              to: "/fleetdashboard/Fleetdashboardmodule",
            },
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View Vehicle Expense Dashboard")
        ? [
            {
            label: "Vehicle Expenses",
            icon: ReceiptLongIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View Vendor Payment Dashboard")
        ? [
            {
            label: "Vendor Payments",
            icon: PaymentsIcon,
            to: "/fleetdashboard/Fleetdashboardmodule",
          }
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View All Overtime Details")
        ? [
            {
              label: "Overtime Details",
              icon: AccessTimeFilledIcon,
              to: "/fleetdashboard/Fleetdashboardmodule",
            }
          ]
        : []),
        ...(showAll ||
      filteredActionNames.includes("View All Customer Reviews")
        ? [
            {
              label: "Customer Reviews",
              icon: ReviewsIcon,
              to: "/fleetdashboard/Fleetdashboardmodule",
            },
          ]
        : []),
        ...(showAll ||
      filteredActionNames.includes("Assign Pickup And Delivery Agent")
        ? [
            {
              label: "Delivery & Pickups Agent Dashboard",
              icon: BadgeIcon,
              to: "/deliverypickupagentdashboard/Deliverypickupagentmodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("View Today Delivery")
        ? [
            {
              label: "Delivery and Pickup Details",
              icon: AltRouteIcon,
              to: "/deliverypickupagentdashboard/Deliverypickupagentmodule",
            },
          ]
        : []),
    ],
  },
  // deliverypickupsagentdashboard: {
  //   sidebar: [
  //     ...(showAll ||
  //     filteredActionNames.includes("Assign Pickup And Delivery Agent")
  //       ? [
  //           {
  //             label: "Delivery & Pickups Agent Dashboard",
  //             icon: DashboardIcon,
  //             to: "/deliverypickupagentdashboard/Deliverypickupagentmodule",
  //           },
  //         ]
  //       : []),
  //     ...(showAll || filteredActionNames.includes("View Today Delivery")
  //       ? [
  //           {
  //             label: "Delivery and Pickup Details",
  //             icon: DashboardIcon,
  //             to: "/deliverypickupagentdashboard/Deliverypickupagentmodule",
  //           },
  //         ]
  //       : []),
  //   ],
  // },
  partnerwithus: {
    sidebar: [
      hasFullAccess
        ? {
            label: "Partner With Us",
            icon: DashboardIcon,
            to: "/partnerwithus/Partnerwithusmodule",
          }
        : [],
    ],
  },
  subscriptiondashboard: {
    sidebar: [
      ...(showAll ||
      filteredActionNames.includes("View All Subscription Inquiry")
        ? [
            {
              label: "Subscription Dashboard",
              icon: DashboardIcon,
              to: "/cusomtersubscription/Customersubscriptionmodule",
            },
          ]
        : []),
    ],
  },
  vehiclesdashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View All Vehicles")
        ? [
            {
              label: "View all Vehicles",
              icon: DashboardIcon,
              to: "/cusomtersubscription/Customersubscriptionmodule",
            },
          ]
        : []),
        ...(showAll || filteredActionNames.includes("View All Vehicles")
        ? [
            {
              label: "View all Vehicle Groups",
              icon: DashboardIcon,
              to: "/cusomtersubscription/Customersubscriptionmodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("Create Vehicle")
        ? [
            {
              label: "Create New Vehicle",
              icon: AddCircleOutlineIcon,
              to: "/cusomtersubscription/Customersubscriptionmodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("View Block Vehicles")
        ? [
            {
              label: "Blocked Vehicles",
              icon: DashboardIcon,
              to: "/cusomtersubscription/Customersubscriptionmodule",
            },
          ]
        : []),
      // ...(showAll || filteredActionNames.includes("View All Vehicles")
      //   ? [
      //       {
      //         label: "Fleet Utilization History",
      //         icon: DashboardIcon,
      //         to: "/fleetutilizationhistory/FleetUtilizationHistorymodule",
      //       },
      //     ]
      //   : []),
      ...(showAll || filteredActionNames.includes("View All Vehicles")
        ? [
            {
              label: "Vehicle Doc Expiry Details",
              icon: DashboardIcon,
              to: "/documents/vehicle-doc-expiry-details",
            },
          ]
        : []),
    ],
  },
  viewallissuea: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View all Issues")
        ? [
            {
              label: "View all Issues",
              icon: DashboardIcon,
              to: "/issues/Issuesmodulw",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("Create Issue")
        ? [
            {
              label: "Create New Issue",
              icon: DashboardIcon,
              to: "/issues/Issuesmodulw",
            },
          ]
        : []),
    ],
  },
  // usermanagement: {
  //   sidebar: [
  //     ...(showAll || filteredActionNames.includes("View All User Management")
  //       ? [
  //           {
  //             label: "User Management Dashboard",
  //             icon: SupervisorAccountIcon,
  //             to: "/usermanagement/UserManagementModule",
  //           },
  //         ]
  //       : []),
  //   ],
  // },
  // helpdesk: {
  //   sidebar: [
  //     ...(showAll || filteredActionNames.includes("View Helpdesk Dashboard") || filteredActionNames.includes("View all Issues")
  //       ? [
  //           {
  //             label: "Helpdesk & Tasks",
  //             icon: SupportAgentIcon,
  //             value: false,
  //             to: "/helpdesk",
  //           },
  //         ]
  //       : []),
  //     ...(showAll || filteredActionNames.includes("Create Helpdesk Ticket") || filteredActionNames.includes("Create Issue")
  //       ? [
  //           {
  //             label: "Create New Ticket",
  //             icon: ConfirmationNumberIcon, 
  //             value: false,
  //             to: "/helpdesk/CreateTicket",
  //           },
  //         ]
  //       : []),
  //     ...(showAll || filteredActionNames.includes("View My Tickets")
  //       ? [
  //           {
  //             label: "My Assigned Tasks",
  //             icon: HelpOutlineIcon,
  //             value: true,
  //             to: "/helpdesk/MyTickets",
  //           },
  //         ]
  //       : []),
  //   ],
  // },
  customermanagement: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View All Customer")
        ? [
            {
              label: "View all Customers",
              icon: SupervisorAccountIcon,
              to: "/customermanagement/customermanagementmodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("View All Customer")
        ? [
            {
              label: "View all Feedbacks",
              icon: FeedbackIcon,
              to: "/customermanagement/customermanagementmodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("View All Customer")
        ? [
            {
              label: "View Archived Customers",
              icon: ArchiveIcon,
              to: "/customermanagement/customermanagementmodule",
            },
          ]
        : []),
    ],
  },
  salesagentdashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Sales Agent Dashboard")
        ? [
            {
              label: "View My Sales",
              icon: FeedbackIcon,
              to: "/salesagentdashboard/SalesAgentDashboardModule",
            },
          ]
        : []),
      ...(showAll ||
      privilegedAcessForAccounts ||
      filteredActionNames.includes("View Sales Dashboard")
        ? [
            {
              label: "Sales Dashboard",
              icon: FeedbackIcon,
              to: "/salesagentdashboard/SalesAgentDashboardModule",
            },
          ]
        : []),
    ],
  },
  workorder: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View All Workorder")
        ? [
            {
              label: "Workorders Dashboard",
              icon: DashboardIcon,
              to: "/workorder/workordermodule",
            },
          ]
        : []),
      ...(showAll || filteredActionNames.includes("Add Update Workorder")
        ? [
            {
              label: "Add New Work Order",
              icon: FeedbackIcon,
              to: "/workorder/workordermodule",
            },
          ]
        : []),
    ],
  },
  bookingledger: {
    sidebar: [
      ...(showAll ||
      filteredActionNames.includes("View Booking Ledger Dashboard")
        ? [
            {
              label: "Booking Ledger",
              icon: FeedbackIcon,
              to: "/bookingledgerdashboard/bookingledgermodule",
            },
          ]
        : []),
    ],
  },
  recoverypending: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Recovery Dashboard")
        ? [
            {
              label: "Recovery Pending Dashboard",
              icon: DashboardIcon,
              to: "/recoverypending/RecoveryPendingModule",
            },
          ]
        : []),
    ],
  },
  kyv: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Get Vehicle Details")
        ? [
            {
              label: "Know Your Vehicle",
              icon: DirectionsCarFilledIcon,
              to: "/kyv/Kyvmodule",
            },
          ]
        : []),
    ],
  },
  
  fleetoperation: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Fleet Operation Dashboard")
        ? [
            {
              label: "Fleet Operation Dashboard",
              icon: DashboardIcon,
              to: "/fleetoperation/FleetOperationModule",
            },
          ]
        : []),
    ],
  },
  clutchnotification: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Clutch Notification Dashboard")
        ? [
            {
              label: "Clutch Notification Dashboard",
              icon: DashboardIcon,
              to: "/clutchnotification/ClutchNotificationModule",
            },
          ]
        : []),
    ],
  },
  bookinganalytics: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Booking Analytics")
        ? [
            {
              label: "Booking Analytics",
              icon: DirectionsCarFilledIcon,
              to: "/bookinganalytics/Bookinganalyticsmodule",
            },
          ]
        : []),
    ],
  },
  fleetutilization: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Fleet Utilization")
        ? [
            {
              label: "View Fleet Utilization",
              icon: DirectionsCarFilledIcon,
              to: "/fleetutilization/Fleetutilizationmodule",
            },
          ]
        : []),
    ],
  },
  pettycashdashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Petty Cash Dashboard")
        ? [
            {
              label: "Petty Cash Dashboard",
              icon: DirectionsCarFilledIcon,
              to: "/pettycashdashboard/Pettycashdashboardmodule",
            },
          ]
        : []),
    ],
  },
  vehiclegroupsales: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("View Segmented Sales Dashboard")
        ? [
            {
              label: "Vehicle Group Sales Dashboard",
              icon: DashboardIcon,
              to: "/vehiclegroupsales/VehiclegroupsalesModule",
            },
          ]
        : []),
    ],
  },
  wheelalignmentdashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Wheel Alignment Dashboard")
        ? [
            {
              label: "Wheel Alignment Dashboard",
              icon: DashboardIcon,
              to: "/wheelalignmentdashboard/Wheelalignmentmodule",
            },
          ]
        : []),
    ],
  },
  vehicledocumentdashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Vehicle Document Dashboard")
        ? [
            {
              label: "Vehicle Document Dashboard",
              icon: DashboardIcon,
              to: "/vehicledocumentdashboard/Vehicledocumentmodule",
            },
          ]
        : []),
    ],
  },
  vehicleemidashboard: {
    sidebar: [
      ...(showAll || filteredActionNames.includes("Vehicle EMI Dashboard")
        ? [
            {
              label: "Vehicle EMI Dashboard",
              icon: DashboardIcon,
              to: "/vehicleemidashboard/Vehicleemimodule",
            },
          ]
        : []),
    ],
  },
};
